import { InvoiceDateType } from "../enums/global.enums";

export function invoiceDateTypePipe(value: string) {
    switch (value) {
        case InvoiceDateType.All: return "Tất cả";
        case InvoiceDateType.InMonth: return "Từ đầu tháng đến cuối tháng";
        case InvoiceDateType.ByReadDate: return "Theo ngày đọc khu vực hoặc thực tế";
    }
    return "";
}

export const INVOICE_DATE_TYPES = [
    InvoiceDateType.InMonth,
    InvoiceDateType.ByReadDate,
];
